import { CSSProperties, ReactNode, Ref } from 'react';
import { cn } from '@anytag/shared-utils';

export interface TextCutterProps {
  id?: string;
  lines?: number;
  title?: string;
  className?: string;
  style?: CSSProperties;
  onClick?: () => void;
  text: ReactNode | null;
  ref?: Ref<HTMLParagraphElement>;
}

export const TextCutter = ({ id, style, text, title, lines = 1, className, onClick, ref }: TextCutterProps) => (
  <p
    tabIndex={ref ? -1 : undefined} // to make shouldFocusError ref work, element needs to be focusable
    id={id}
    ref={ref}
    onClick={onClick}
    className={cn('h-fit overflow-hidden break-all text-ellipsis whitespace-normal text-inherit', className)}
    title={typeof title === 'undefined' ? (typeof text === 'string' ? text : '') : title}
    style={{ WebkitLineClamp: lines, WebkitBoxOrient: 'vertical', display: '-webkit-box', ...style }}
  >
    {text}
  </p>
);
